import { api } from "api/api";
import { AxiosError } from "axios";
import Processo from "model/indicadores/Processo";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class ProcessoService implements BaseServiceCadastros<Processo> {
    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {

            let url = `/processo/pesquisar`;
            url += getFilters(filters)

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<Processo>((resolve, reject): void => {
            api
                .get(`/processo/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(processo: Processo) {
        return new Promise<Processo>((resolve, reject): void => {
            let url = `/processo/incluir`;
            api
                .post(url, JSON.stringify(processo))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(processo: Processo) {
        return new Promise<Processo>((resolve, reject): void => {
            api
                .put(`/processo/editar`, JSON.stringify(processo))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/processo/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}

export default ProcessoService;